module.exports = __webpack_public_path__ + "static/img/01@2x (1).a9b6715.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/01@2x (1).png
// module id = AVNL
// module chunks = 1